import script from "./AuthLegalLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLegalLinks.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__